export const FETCH_PROMO_CODE_USAGE = 'FETCH_PROMO_CODE_USAGE';
export const FETCH_PROMO_CODE_USAGE_SUCCESS = 'FETCH_PROMO_CODE_USAGE_SUCCESS';
export const FETCH_PROMO_CODE_USAGE_FAILS = 'FETCH_PROMO_CODE_USAGE_FAILS';